import { Config } from "common/config";
import { MenuContext } from "common/contexts/Menu";
import { FlexWrapper } from "components/Styled/Styled";
import { useContext } from "react";
import { Component } from "..";
import { Container, Item, Link } from "./styled";
import { Fade } from "react-awesome-reveal";

export const Menu = () => {
  const { setIsOpen } = useContext(MenuContext);

  const onItemClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Container>
        <Fade
          cascade
          triggerOnce
          direction="up"
          delay={800}
          duration={500}
          damping={0.5}
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "28px",
          }}
        >
          {Config.links.map((link, index) => (
            <Link href={link.href} key={index} onClick={onItemClick}>
              <Item>{link.title}</Item>
            </Link>
          ))}
        </Fade>
      </Container>
    </>
  );
};
